var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EncryptedEndpoint_instances, _EncryptedEndpoint_pendingNonces, _EncryptedEndpoint_nonceTimestamps, _EncryptedEndpoint_cleanupNonces;
import * as protobuf from 'protobufjs';
import { AES, RSA } from '@datarock/cryptography';
import { VCryptoHashFunction, VPacket } from '@datarock/protobuffers';
import { EncodedEndpoint } from './Encoded';
import omit from 'lodash/omit';
export class EncryptedEndpoint extends EncodedEndpoint {
    constructor(options) {
        super(options);
        _EncryptedEndpoint_instances.add(this);
        _EncryptedEndpoint_pendingNonces.set(this, void 0);
        _EncryptedEndpoint_nonceTimestamps.set(this, void 0);
        __classPrivateFieldSet(this, _EncryptedEndpoint_pendingNonces, new Set(), "f");
        __classPrivateFieldSet(this, _EncryptedEndpoint_nonceTimestamps, new Map(), "f");
        // Set up periodic cleanup of old nonces
        setInterval(() => __classPrivateFieldGet(this, _EncryptedEndpoint_instances, "m", _EncryptedEndpoint_cleanupNonces).call(this), 5 * 60 * 1000);
    }
    async getRequestInit(body) {
        const { keys } = this.constructor;
        if (!keys) {
            throw new Error('Missing encryption keys');
        }
        if (!keys.symmetricKey) {
            throw new Error('Missing symmetric key');
        }
        if (!keys.signingKey) {
            throw new Error('Missing signing key');
        }
        if (!keys.sessionId) {
            throw new Error('Missing session ID');
        }
        const iv = await AES.getRandomValues(16);
        const contents = await AES.encrypt(keys.symmetricKey, iv, body);
        const hash = await RSA.sign(keys.signingKey, contents);
        const nonce = (new Date().getTime() * 10000).toString();
        __classPrivateFieldGet(this, _EncryptedEndpoint_pendingNonces, "f").add(nonce);
        __classPrivateFieldGet(this, _EncryptedEndpoint_nonceTimestamps, "f").set(nonce, Date.now());
        const requestBytes = VPacket.encode({
            contents,
            iv,
            nonce,
            sessionId: keys.sessionId,
            signature: {
                function: VCryptoHashFunction.SHA_256,
                hash
            }
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        var _a;
        const { keys } = this.constructor;
        if (!keys) {
            throw new Error('Missing encryption keys');
        }
        if (!keys.symmetricKey) {
            throw new Error('Missing symmetric key');
        }
        const decoded = await super.process(value, ...args);
        let packet;
        try {
            packet = VPacket.decode(decoded);
        }
        catch (error) {
            // Check for various protobufjs error types
            if (error instanceof protobuf.util.ProtocolError) {
                throw new Error('Invalid message received from server (missing required fields)');
            }
            // RangeError for index out of range
            if (error instanceof RangeError) {
                throw new Error('Invalid message received from server (index out of range)');
            }
            // Check error message for common protobuf decoding errors
            const errorMessage = (error === null || error === void 0 ? void 0 : error.message) || '';
            if (errorMessage.includes('invalid wire type') ||
                errorMessage.includes('illegal wire type')) {
                throw new Error('Invalid message received from server (invalid wire type)');
            }
            if (errorMessage.includes('truncated') ||
                errorMessage.includes('unexpected end')) {
                throw new Error('Invalid message received from server (truncated message)');
            }
            if (errorMessage.includes('index out of range')) {
                throw new Error('Invalid message received from server (index out of range)');
            }
            throw error;
        }
        if (packet.nonce) {
            if (__classPrivateFieldGet(this, _EncryptedEndpoint_pendingNonces, "f").has(packet.nonce)) {
                __classPrivateFieldGet(this, _EncryptedEndpoint_pendingNonces, "f").delete(packet.nonce);
                __classPrivateFieldGet(this, _EncryptedEndpoint_nonceTimestamps, "f").delete(packet.nonce);
            }
            else {
                throw new Error('Unexpected nonce');
            }
        }
        const verificationBytes = VPacket.encode(VPacket.fromPartial(omit(packet, 'signature'))).finish();
        const serverHash = (_a = packet.signature) === null || _a === void 0 ? void 0 : _a.hash;
        if (serverHash) {
            if (!keys.serverPublicKey) {
                throw new Error('Missing server public key');
            }
            const verified = await RSA.verify(keys.serverPublicKey, serverHash, verificationBytes);
            if (!verified) {
                throw new Error('Verifying Server signing failed');
            }
        }
        else {
            throw new Error('Verifying Server signing failed');
        }
        return await AES.decrypt(keys.symmetricKey, packet.iv, packet.contents);
    }
}
_EncryptedEndpoint_pendingNonces = new WeakMap(), _EncryptedEndpoint_nonceTimestamps = new WeakMap(), _EncryptedEndpoint_instances = new WeakSet(), _EncryptedEndpoint_cleanupNonces = function _EncryptedEndpoint_cleanupNonces(maxAge = 5 * 60 * 1000) {
    const now = Date.now();
    __classPrivateFieldGet(this, _EncryptedEndpoint_nonceTimestamps, "f").forEach((t, nonce) => {
        if (now - t > maxAge) {
            __classPrivateFieldGet(this, _EncryptedEndpoint_pendingNonces, "f").delete(nonce);
            __classPrivateFieldGet(this, _EncryptedEndpoint_nonceTimestamps, "f").delete(nonce);
        }
    });
};
